import { render, staticRenderFns } from "./sortGoods.vue?vue&type=template&id=639935ce&scoped=true&"
import script from "./sortGoods.vue?vue&type=script&lang=js&"
export * from "./sortGoods.vue?vue&type=script&lang=js&"
import style0 from "./sortGoods.vue?vue&type=style&index=0&id=639935ce&prod&langs=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639935ce",
  null
  
)

export default component.exports